import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const mobileItems = [
    { name: 'Burger Smash + fritas', price: 'R$ 36,90' },
    { name: 'Salmao grelhado', price: 'R$ 54,00' },
    { name: 'Cheesecake de frutas', price: 'R$ 19,00' },
];

const VisualDemo: React.FC = () => {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ['start start', 'end end']
    });

    const scale = useTransform(scrollYProgress, [0, 0.4, 0.6, 1], [0.85, 1, 1, 0.9]);
    const rotate = useTransform(scrollYProgress, [0, 0.4], [5, 0]);
    const mobileX = useTransform(scrollYProgress, [0.4, 0.55], [0, -60]);
    const panelX = useTransform(scrollYProgress, [0.4, 0.55], [0, 60]);
    const opacity = useTransform(scrollYProgress, [0, 0.1, 0.9, 1], [0, 1, 1, 0]);

    return (
        <section ref={containerRef} className="relative h-[300vh] bg-background">
            <motion.div 
                style={{ opacity }}
                className="sticky top-0 flex h-screen w-full flex-col items-center justify-center overflow-hidden px-5"
            >
                <div className="mx-auto w-full max-w-[1400px]">
                    <motion.div
                        style={{ y: useTransform(scrollYProgress, [0, 0.2], [50, 0]) }}
                        className="mb-14 space-y-5 text-center md:mb-20"
                    >
                        <h2 className="text-4xl font-black tracking-tighter text-white md:text-7xl italic">
                            Simplicidade <span className="text-primary italic">extrema.</span>
                        </h2>
                        <p className="mx-auto max-w-2xl text-lg text-secondary md:text-xl">
                            A tecnologia deve ser invisível. Uma interface que acelera o atendimento <br/> sem obstáculos técnicos.
                        </p>
                    </motion.div>

                    <motion.div
                        style={{ scale, rotateX: rotate }}
                        className="relative mx-auto w-full overflow-hidden rounded-[42px] border border-white/10 bg-[#0b0d12] p-4 shadow-[0_50px_200px_rgba(0,0,0,0.8)] md:p-6"
                    >
                        <div className="grid gap-6 lg:grid-cols-[340px_1fr]">
                            <motion.div 
                                style={{ x: mobileX }} 
                                className="rounded-[36px] border border-white/10 bg-[#090b10] p-4 shadow-2xl"
                            >
                                <div className="mx-auto w-full max-w-[280px] space-y-4">
                                    <div className="h-1.5 w-16 mx-auto rounded-full bg-white/10" />
                                    <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-primary/20 to-transparent p-5">
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-primary">Mobile First</p>
                                        <h4 className="mt-2 text-xl font-bold text-white">Menu QR Code</h4>
                                    </div>
                                    <div className="space-y-3">
                                        {mobileItems.map((item, i) => (
                                            <div key={i} className="flex items-center gap-3 rounded-2xl bg-white/[0.03] p-2.5">
                                                <div className="h-10 w-10 rounded-xl bg-white/5" />
                                                <div className="flex-1 space-y-1.5">
                                                    <div className="h-2 w-20 rounded bg-white/10" />
                                                    <div className="h-2 w-12 rounded bg-primary/20" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="h-12 w-full rounded-2xl bg-primary shadow-glow-sm flex items-center justify-center text-white font-bold text-sm">
                                        Finalizar Pedido
                                    </div>
                                </div>
                            </motion.div>

                            <motion.div 
                                style={{ x: panelX }} 
                                className="rounded-[36px] border border-white/10 bg-[#11141b] p-6 shadow-2xl overflow-hidden"
                            >
                                <div className="flex items-center justify-between mb-8">
                                    <div>
                                        <p className="text-[10px] font-bold uppercase tracking-widest text-primary">Master View</p>
                                        <h4 className="mt-2 text-2xl font-bold text-white">O coração do restaurante</h4>
                                    </div>
                                    <div className="flex gap-2">
                                        <div className="h-2.5 w-2.5 rounded-full bg-red-500/30" />
                                        <div className="h-2.5 w-2.5 rounded-full bg-yellow-500/30" />
                                        <div className="h-2.5 w-2.5 rounded-full bg-green-500/30" />
                                    </div>
                                </div>
                                <div className="grid gap-4 sm:grid-cols-3">
                                    {[1, 2, 3].map(i => (
                                        <div key={i} className="h-24 rounded-2xl bg-white/[0.03] border border-white/5 p-4">
                                            <div className="h-2 w-12 bg-white/10 rounded mb-3" />
                                            <div className="h-4 w-20 bg-white/20 rounded" />
                                        </div>
                                    ))}
                                </div>
                                <div className="mt-6 rounded-2xl border border-white/5 bg-white/[0.02] p-6 h-48">
                                    <div className="flex items-center justify-between mb-6">
                                        <div className="h-3 w-32 bg-white/10 rounded" />
                                        <div className="h-6 w-16 bg-primary/10 rounded-full" />
                                    </div>
                                    <div className="space-y-4">
                                        {[1, 2].map(i => (
                                            <div key={i} className="flex justify-between items-center bg-white/[0.02] p-3 rounded-xl">
                                                <div className="flex gap-3 items-center">
                                                    <div className="h-8 w-8 rounded-lg bg-white/5" />
                                                    <div className="h-2 w-24 bg-white/10 rounded" />
                                                </div>
                                                <div className="h-2 w-12 bg-white/10 rounded" />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </section>
    );
};

export default VisualDemo;
